import { cn } from '#app/utils/misc.tsx'
import { Button } from './ui/button.tsx'

interface VideoSectionProps {
	className?: string
}

export function VideoSection({ className }: VideoSectionProps) {
	return (
		<section
			className={cn(
				'relative flex min-h-[600px] flex-col items-center justify-center px-4 py-8 md:min-h-[1215px] md:px-55 md:py-25',
				className,
			)}
			style={{
				backgroundImage:
					"url('/resources/images?src=%2Fimg%2Fsection3-bg.png&w=1440&h=1315&format=webp')",
				backgroundSize: 'cover',
				backgroundPosition: 'center',
				backgroundRepeat: 'no-repeat',
			}}
		>
			{/* Content Wrapper */}
			<div className="relative z-10 flex w-full max-w-[1008px] flex-col items-center gap-16">
				{/* Main Heading - Responsive sizing siguiendo Figma */}
				<div className="px-4 text-center">
					<h2 className="font-parkinsans text-[24px] leading-[32px] font-normal text-blue-800 md:text-[64px] md:leading-[88px]">
						Cuidar el ambiente no es una opción,{' '}
						<span className="font-medium md:text-green-500">
							es parte de nuestro propósito
						</span>
					</h2>
				</div>

				{/* Button - Mobile siguiendo Figma exacto */}
				<Button
					size="m"
					variant="secondary"
					className="rounded-[12px] px-4 py-3 text-[14px] leading-[16px] md:hidden"
				>
					Descubrí más sobre nosotros
				</Button>

				{/* Button - Desktop */}
				<Button size="l" variant="secondary" className="hidden md:flex">
					Descubrí más sobre nosotros
				</Button>

				{/* Video Section - Desktop only (dentro del contenedor) */}
				<div className="relative mt-16 hidden w-full max-w-[1200px] overflow-hidden rounded-[24px] md:block">
					{/* Video container con aspect ratio desktop */}
					<div className="aspect-video">
						{/* Video Local Optimizado */}
						<video
							width="100%"
							height="100%"
							controls
							preload="metadata"
							className="rounded-[24px] object-cover"
							poster="/img/video-thumbnail.jpg"
						>
							<source
								src="/videos/100prevalor_presentacion.mp4"
								type="video/mp4"
							/>
							Tu navegador no soporta el elemento video.
						</video>
					</div>

					{/* Decorative Overlay - Desktop only */}
					<div className="pointer-events-none absolute top-[288px] left-[550px] h-[100px] w-[100px]">
						{/* You can add a decorative SVG or image here if needed */}
					</div>
				</div>
			</div>

			{/* Video Section - Mobile full width (fuera del contenedor) */}
			<div className="relative mt-16 w-screen overflow-hidden md:hidden">
				{/* Video container con aspect ratio mobile específico */}
				<div className="aspect-[389/220]">
					{/* Video Local Optimizado - Mobile */}
					<video
						width="100%"
						height="100%"
						controls
						preload="metadata"
						className="object-cover"
						poster="/img/video-thumbnail-mobile.jpg"
					>
						<source
							src="/videos/100prevalor_presentacion.mp4"
							type="video/mp4"
						/>
						Tu navegador no soporta el elemento video.
					</video>
				</div>
			</div>
		</section>
	)
}

export default VideoSection
